import {createAsyncThunk} from '@reduxjs/toolkit';
import {addChange, clearChanges, setChangesDetected} from '../store/ChangeDetected';
import {useDispatch} from 'react-redux';
import {setIsChangeBan} from '../store/ChangeBan';

export const useChanges = () => {
  const dispatch = useDispatch();

  const updateData = createAsyncThunk(
    'Data/updateData',
    async ({updateApiFunction, getApiFunction}, thunkAPI) => {
      const changes = thunkAPI.getState().changeDetected.changes;
      const {serverId} = thunkAPI.getState().serverId;
      console.log('changes', changes);
      const response = await updateApiFunction(serverId, changes);
      console.log('response', response);
      thunkAPI.dispatch(setIsChangeBan(false));

      if (response.status === 200) {
        thunkAPI.dispatch(getApiFunction());
      }

      thunkAPI.dispatch(clearChanges());
      thunkAPI.dispatch(setChangesDetected(false));
    },
  );

  const handleSaveChanges = async (updateApiFunction, getApiFunction) => {
    await dispatch(updateData({updateApiFunction, getApiFunction}));
  };

  const cancelChanges = () => {
    dispatch(setChangesDetected(false));
  };

  const addChangeToStore = (payload) => {
    dispatch(addChange(payload));
    dispatch(setChangesDetected(true));
  };

  return {updateData, cancelChanges, addChangeToStore, handleSaveChanges};
};
